import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

export default function() {
  const atoms = require.context('@/components/atoms', true, /\.vue$/)
  const commonMolecules = require.context('@/components/molecules/common', true, /\.vue$/)
  const proaComponents = {}

  atoms.keys().forEach(key => {
    proaComponents[key.replace(/(\.\/|\.vue)/g, '')] = atoms(key).default
  })

  commonMolecules.keys().forEach(key => {
    proaComponents[key.replace(/(\.\/|\.vue)/g, '')] = commonMolecules(key).default
  })

  Object.keys(proaComponents).forEach(key => {
    Vue.component(key, proaComponents[key])
  })

  // Bootstrap
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
}
